export interface GlossaryTerm {
  term: string;
  description: string;
  category: string;
}

const glossaryData: GlossaryTerm[] = [
  // 거래
  { term: "실거래가", description: "부동산이 실제로 거래된 가격으로, 국토교통부에 신고된 금액을 말합니다.", category: "거래" },
  { term: "호가", description: "매도자가 희망하는 매매 가격으로, 실거래가와 차이가 있을 수 있습니다.", category: "거래" },
  { term: "매매", description: "부동산의 소유권을 대가를 지불하고 이전하는 거래 형태입니다.", category: "거래" },
  { term: "전세", description: "보증금을 맡기고 일정 기간 부동산을 사용하는 임대차 형태입니다. 월세 없이 보증금만 지불합니다.", category: "거래" },
  { term: "월세", description: "보증금과 함께 매월 일정 금액을 임대료로 지불하는 임대차 형태입니다.", category: "거래" },
  { term: "반전세", description: "전세와 월세의 중간 형태로, 전세보증금 일부를 월세로 전환한 계약입니다.", category: "거래" },
  { term: "갭투자", description: "전세가와 매매가의 차이(갭)만큼의 자금으로 부동산을 매입하는 투자 방식입니다.", category: "거래" },
  { term: "분양가상한제", description: "공공택지에서 분양하는 아파트의 분양가에 상한을 두는 제도입니다.", category: "거래" },
  { term: "청약", description: "새로 분양하는 아파트를 공급받기 위해 신청하는 절차입니다.", category: "거래" },
  { term: "전매제한", description: "분양권이나 입주권의 매매를 일정 기간 제한하는 규제입니다.", category: "거래" },
  { term: "등기", description: "부동산에 관한 권리관계를 등기부에 기록하여 공시하는 것입니다.", category: "거래" },
  { term: "중도금", description: "분양 계약 후 잔금 납부 전까지 나눠서 내는 금액입니다.", category: "거래" },
  { term: "계약금", description: "매매 계약 시 계약 체결의 의미로 먼저 지불하는 금액으로, 통상 매매가의 10%입니다.", category: "거래" },
  { term: "잔금", description: "계약금과 중도금을 제외한 나머지 금액으로, 잔금 지급일에 소유권이 이전됩니다.", category: "거래" },
  { term: "경매", description: "법원의 강제집행 절차에 따라 부동산을 매각하는 것으로, 시세보다 저렴하게 취득할 수 있습니다.", category: "거래" },
  { term: "공매", description: "한국자산관리공사(캠코) 등이 체납 재산을 매각하는 절차로, 경매와 유사하지만 법원을 거치지 않습니다.", category: "거래" },
  { term: "분양권", description: "아파트 분양 당첨 후 입주 전까지 갖는 권리로, 전매가 가능한 경우 매매할 수 있습니다.", category: "거래" },
  { term: "입주권", description: "재건축·재개발 조합원이 새 아파트에 입주할 수 있는 권리입니다.", category: "거래" },

  // 세금
  { term: "취득세", description: "부동산을 취득할 때 납부하는 지방세입니다. 주택 가격과 보유 주택 수에 따라 세율이 달라집니다.", category: "세금" },
  { term: "양도소득세", description: "부동산을 매도하여 발생한 차익에 대해 부과되는 국세입니다.", category: "세금" },
  { term: "종합부동산세", description: "일정 기준을 초과하는 부동산을 보유한 사람에게 부과되는 국세입니다.", category: "세금" },
  { term: "재산세", description: "매년 6월 1일 기준 부동산 소유자에게 부과되는 지방세입니다.", category: "세금" },
  { term: "공시가격", description: "정부가 매년 발표하는 부동산의 공식 평가 가격으로, 세금 산정의 기준이 됩니다.", category: "세금" },
  { term: "기준시가", description: "국세청이 정하는 부동산 가격으로, 양도세·상속세·증여세 산정 기준입니다.", category: "세금" },
  { term: "1세대 1주택 비과세", description: "1세대가 1주택을 2년 이상 보유(조정지역은 거주 포함) 후 매도 시 양도소득세가 비과세되는 혜택입니다.", category: "세금" },
  { term: "다주택자 중과", description: "2주택 이상 보유자에게 양도소득세와 종합부동산세를 중과세율로 부과하는 제도입니다.", category: "세금" },
  { term: "증여세", description: "부동산을 무상으로 양도받을 때 부과되는 세금으로, 가족 간 증여 시 공제 한도가 있습니다.", category: "세금" },
  { term: "상속세", description: "피상속인 사망으로 부동산을 물려받을 때 부과되는 세금입니다.", category: "세금" },
  { term: "부가가치세", description: "상업용 부동산(상가, 오피스텔 등) 거래 시 건물분에 대해 부과되는 세금입니다.", category: "세금" },

  // 재건축
  { term: "재건축", description: "노후된 아파트 등을 철거하고 새로 건축하는 정비사업입니다. 주로 정비기반시설이 양호한 지역에서 시행됩니다.", category: "재건축" },
  { term: "재개발", description: "정비기반시설이 열악한 낙후 지역의 주거환경을 개선하기 위한 정비사업입니다.", category: "재건축" },
  { term: "안전진단", description: "재건축 추진을 위해 건축물의 구조 안전성, 노후도 등을 종합 평가하는 절차입니다.", category: "재건축" },
  { term: "조합설립인가", description: "재건축·재개발 조합을 설립하기 위해 관할 지자체의 인가를 받는 단계입니다.", category: "재건축" },
  { term: "관리처분계획", description: "정비사업에서 조합원의 권리와 분양 물량, 비용 분담 등을 확정하는 계획입니다.", category: "재건축" },
  { term: "초과이익환수제", description: "재건축으로 발생하는 초과이익의 일부를 부담금으로 환수하는 제도입니다.", category: "재건축" },
  { term: "용적률", description: "대지면적 대비 건축물 연면적의 비율로, 높을수록 더 많은 세대를 지을 수 있습니다.", category: "재건축" },
  { term: "건폐율", description: "대지면적 대비 건축면적의 비율로, 땅에서 건물이 차지하는 면적 비율입니다.", category: "재건축" },
  { term: "일반분양", description: "재건축·재개발에서 조합원 물량을 제외하고 일반인에게 분양하는 세대입니다.", category: "재건축" },
  { term: "비례율", description: "재건축·재개발 사업의 수익성을 나타내는 지표로, 100% 이상이면 수익이 발생합니다.", category: "재건축" },

  // 대출
  { term: "LTV (주택담보대출비율)", description: "주택 가격 대비 대출 가능한 비율입니다. LTV 70%면 5억 주택에 3.5억까지 대출 가능합니다.", category: "대출" },
  { term: "DTI (총부채상환비율)", description: "연소득 대비 연간 부채 원리금 상환액의 비율입니다. 대출 상환 능력을 판단하는 기준입니다.", category: "대출" },
  { term: "DSR (총부채원리금상환비율)", description: "모든 대출의 연간 원리금 상환액을 연소득으로 나눈 비율입니다. DTI보다 엄격한 기준입니다.", category: "대출" },
  { term: "고정금리", description: "대출 기간 동안 금리가 변하지 않는 방식으로, 금리 상승 시 유리합니다.", category: "대출" },
  { term: "변동금리", description: "시장 금리에 따라 대출 금리가 변동하는 방식입니다.", category: "대출" },
  { term: "원리금균등분할상환", description: "매월 원금과 이자를 합한 동일한 금액을 상환하는 방식입니다.", category: "대출" },
  { term: "전세자금대출", description: "전세 보증금 마련을 위해 받는 대출로, 주택 구매 대출보다 금리가 낮은 편입니다.", category: "대출" },
  { term: "디딤돌대출", description: "무주택 서민을 위한 정부 지원 주택구입 대출로, 시중보다 낮은 금리를 제공합니다.", category: "대출" },
  { term: "보금자리론", description: "한국주택금융공사가 제공하는 장기 고정금리 주택담보대출 상품입니다.", category: "대출" },
  { term: "중도상환수수료", description: "대출 만기 전에 원금을 상환할 때 부과되는 수수료로, 보통 3년 이내 상환 시 적용됩니다.", category: "대출" },
  { term: "스트레스 DSR", description: "미래 금리 상승 가능성을 반영하여 가산금리를 더해 DSR을 산출하는 강화된 기준입니다.", category: "대출" },

  // 지표
  { term: "PIR (소득 대비 주택가격 비율)", description: "연소득 대비 주택 가격의 비율로, 주택 구매 부담을 나타내는 지표입니다.", category: "지표" },
  { term: "전세가율", description: "매매가 대비 전세가의 비율로, 전세가율이 높으면 갭투자 위험이 커집니다.", category: "지표" },
  { term: "매매가격지수", description: "기준 시점 대비 현재 주택 매매가격의 변동을 수치화한 지표입니다.", category: "지표" },
  { term: "미분양", description: "분양 후 일정 기간 내 계약이 체결되지 않은 주택으로, 시장 과잉 공급의 지표입니다.", category: "지표" },
  { term: "입주물량", description: "특정 기간 내 입주 예정인 아파트 세대수로, 공급 규모를 파악하는 데 사용됩니다.", category: "지표" },
  { term: "거래량", description: "일정 기간 동안 이루어진 부동산 매매 건수로, 시장 활성화 정도를 나타냅니다.", category: "지표" },
  { term: "KB부동산 시세", description: "KB국민은행이 조사·발표하는 부동산 시세로, 대출 심사 등에 널리 활용됩니다.", category: "지표" },
  { term: "HAI (주택구입부담지수)", description: "중위소득 가구가 중위가격 주택을 구입할 때의 대출 상환 부담을 나타내는 지수입니다.", category: "지표" },
  { term: "주택보급률", description: "총 가구수 대비 주택수의 비율로, 100%를 넘으면 주택이 가구수보다 많다는 의미입니다.", category: "지표" },
  { term: "착공물량", description: "특정 기간 내 건축 공사를 시작한 주택 수로, 미래 공급 규모를 예측하는 선행 지표입니다.", category: "지표" },
  { term: "인허가물량", description: "건축 허가를 받은 주택 수로, 착공·입주보다 앞선 단계의 공급 지표입니다.", category: "지표" },

  // 규제·정책
  { term: "투기과열지구", description: "주택 가격 급등 지역에 지정되며, LTV·DTI 규제 강화, 전매제한 등이 적용됩니다.", category: "규제·정책" },
  { term: "조정대상지역", description: "주택 가격 상승이 우려되는 지역으로, 대출 규제와 세금 중과가 적용됩니다.", category: "규제·정책" },
  { term: "토지거래허가구역", description: "토지 투기를 방지하기 위해 지정되며, 일정 면적 이상 거래 시 관할구청 허가가 필요합니다.", category: "규제·정책" },
  { term: "실거주 의무", description: "분양받은 주택에 일정 기간 직접 거주해야 하는 의무로, 전매제한과 함께 적용됩니다.", category: "규제·정책" },
  { term: "임대차 3법", description: "계약갱신청구권, 전월세상한제, 전월세신고제를 통칭하는 임대차 보호 제도입니다.", category: "규제·정책" },
  { term: "계약갱신청구권", description: "임차인이 2년 계약 만료 시 1회에 한해 계약 갱신을 요구할 수 있는 권리입니다.", category: "규제·정책" },
  { term: "전월세상한제", description: "계약 갱신 시 임대료 인상률을 직전 계약의 5% 이내로 제한하는 제도입니다.", category: "규제·정책" },

  // 계약·권리
  { term: "등기부등본", description: "부동산의 소유자, 면적, 권리관계(근저당, 가압류 등)를 확인할 수 있는 공적 문서입니다.", category: "계약·권리" },
  { term: "근저당", description: "채무자가 대출금을 갚지 못할 경우 채권자가 부동산을 처분할 수 있는 담보 설정입니다.", category: "계약·권리" },
  { term: "가압류", description: "채권자가 채무자 재산의 처분을 막기 위해 법원에 신청하는 보전 처분입니다.", category: "계약·권리" },
  { term: "전입신고", description: "새 주소지에 거주 사실을 신고하는 절차로, 임차인의 대항력 확보에 필요합니다.", category: "계약·권리" },
  { term: "확정일자", description: "임대차 계약서에 관공서가 날짜를 확인해주는 것으로, 보증금 우선변제권 확보에 필요합니다.", category: "계약·권리" },
  { term: "대항력", description: "임차인이 제3자(새 소유자 등)에게 임차권을 주장할 수 있는 법적 효력입니다.", category: "계약·권리" },
  { term: "우선변제권", description: "경매 시 임차인이 후순위 채권자보다 보증금을 먼저 돌려받을 수 있는 권리입니다.", category: "계약·권리" },
  { term: "특약사항", description: "매매·임대 계약 시 당사자 간 합의하여 추가하는 조건으로, 계약서에 명시해야 효력이 있습니다.", category: "계약·권리" },
];

export default glossaryData;
